import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip, Select } from 'components';
import { OperatorService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';

interface Props {
	onClose?: any;
	item?: any;
	services: any[];
	document_types: any[];
}

class CreateOperator extends React.Component<Props> {

	state = {
		form: {
			name: '',
	        lastname: '',
	        document: '',
	        address: '',
	        contact_person: '',
	        phone: '',
	        photo: '',
	        document_photo: '',
	        work_experience: '',
	        document_type_id: Constants.DOCUMENT_TYPES.V
		},
		services: [],
		document_types: []
	}

	async componentDidMount() {
		await this.setState({
			document_types: this.props.document_types || []
		});

		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name || '',
					lastname: this.props.item?.lastname || '',
					document: this.props.item?.document || '',
			        address: this.props.item?.address || '',
			        contact_person: this.props.item?.contact_person || '',
			        phone: this.props.item?.phone || '',
			        document_type_id: this.props.item?.document_type_id || Constants.DOCUMENT_TYPES.V
				},
				services: this.props.item?.services.map((i: any) => i.service_id) || []
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (this.props.item != null) {
			await OperatorService.admin.update({
				user_id: this.props.item?.id,
				...this.state.form,
				hasFile: true,
				// @ts-ignore,
				photo: this.state.form.photo?.value || '',
				// @ts-ignore,
				document_photo: this.state.form.document_photo?.value || '',
				// @ts-ignore,
				work_experience: this.state.form.work_experience?.value || '',
				services: JSON.stringify(this.state.services)
			});
			Globals.showSuccess("Se ha modificado el operador correctamente");
			this.props.onClose();
		}
		else {
			if (!this.state.form.photo) {
				Globals.showError('Debe ingresar la foto de perfil');
				return;
			}

			// if (!this.state.form.document_photo) {
			// 	Globals.showError('Debe ingresar la foto del documento de identidad');
			// 	return;
			// }

			// if (!this.state.form.work_experience) {
			// 	Globals.showError('Debe ingresar la experiencia laboral');
			// 	return;
			// }

			await OperatorService.admin.create({
				...this.state.form,
				hasFile: true,
				// @ts-ignore,
				photo: this.state.form.photo?.value || '',
				// @ts-ignore,
				document_photo: this.state.form.document_photo?.value || '',
				// @ts-ignore,
				work_experience: this.state.form.work_experience?.value || '',
				services: JSON.stringify(this.state.services)
			});
			Globals.showSuccess("Se ha creado el operador correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	checkService = (service_id: number) => {
		let services = [...this.state.services];
		const index = this.state.services.findIndex((i: any) => i == service_id);
		if (index == -1) {
			// @ts-ignore
			services.push(service_id);
		}
		else {
			services.splice(index,1);
		}
		this.setState({
			services
		});
	}
	
	render() {
		return (
			<div id="modal-create-operator">
				<form onSubmit={ this.submit }>
					<div className="row">
						<div className="col-md-4 text-center">
							<PaperClip
								className="paperclip-image"
								value={ this.state.form.photo }
								onChange={ (e: any) => {
									this.setState({
										form: {
											...this.state.form,
											photo: e.target
										}
									})
								} }>
								{/*
								// @ts-ignore */}
								<img className={ `selected-image ${ (this.state.form.photo || this.props.item?.photo) ? '' : 'inactive' }` } src={ this.state.form.photo?.dataURL || (this.props.item?.photo ? (Constants.BASE_STORAGE + this.props.item?.photo) : WhiteImage) } />
							</PaperClip>
						</div>
						<div className="col-md-8">
							<div className="row">
								<div className="col-md-6">
									<Input
										color="white"
										value={ this.state.form.name }
										name="name" 
										placeholder="Nombre"
										onChange={ this.change } />
								</div>
								<div className="col-md-6">
									<Input
										color="white"
										value={ this.state.form.lastname }
										name="lastname" 
										placeholder="Apellido"
										onChange={ this.change } />
								</div>
								<div className="col-md-6">
									<div className="container-document">
										<Select
											placeholder="Tipo"
											name="document_type_id"
											onChange={ this.change }
											value={ this.state.form.document_type_id }
											options={ this.state.document_types.map((i: any) => {
												return {
													value: i.id,
													label: i.name
												}
											}) } />
										<Input
											type="number"
											color="white"
											value={ this.state.form.document }
											name="document" 
											placeholder="Documento"
											onChange={ this.change } />
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-4">
							<Input
								type="number"
								color="white"
								value={ this.state.form.phone }
								name="phone" 
								maxLength={ 11 }
								placeholder="Teléfono"
								onChange={ this.change } />
						</div>
						<div className="col-md-4">
							<Input
								color="white"
								value={ this.state.form.address }
								name="address" 
								placeholder="Dirección"
								onChange={ this.change } />
						</div>
						<div className="col-md-4">
							<Input
								color="white"
								value={ this.state.form.contact_person }
								name="contact_person" 
								placeholder="Persona de contacto"
								onChange={ this.change } />
						</div>
					</div>
					<h3>Documento</h3>
					<div className="row">
						<div className="col-md-6">
							<PaperClip
								value={ this.state.form.document_photo }
								successText={ `Cédula Adjuntada` }
								pendingText={ `${ this.props.item != null ? 'Cambiar ' : '' }Cédula de identidad` }
								onChange={ (e: any) => {
									this.setState({
										form: {
											...this.state.form,
											document_photo: e.target
										}
									})
								} } />
						</div>
						<div className="col-md-6">
							<PaperClip
								value={ this.state.form.work_experience }
								successText={ `Experiencia Adjuntada` }
								pendingText={ `${ this.props.item != null ? 'Cambiar ' : '' }Experiencia laboral` }
								onChange={ (e: any) => {
									this.setState({
										form: {
											...this.state.form,
											work_experience: e.target
										}
									})
								} } />
						</div>
					</div>
					<h3>Tipo de servicio que presta</h3>
					{
						this.props.services.map((item: any) => {
							return (
								<div className="td-check">
									<CheckboxTable
										size="small" 
										active={ this.state.services.find((i: any) => i == item.id) != null } 
										onClick={ () => this.checkService(item.id) } />
									{ item.name }
								</div>
							)
						})
					}
					<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default CreateOperator;